import { motion } from "framer-motion";
import { Download, Smartphone } from "lucide-react";
import { useContent } from "@/content/ContentContext";
import { useLang } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1];

export default function AppDownload() {
  const content = useContent();
  const { t } = useLang();
  const app = content.app || {};

  return (
    <section data-testid="app-section" className="border-t border-line">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-10 px-6 py-20 lg:flex-row lg:items-center lg:justify-between lg:px-12 lg:py-24">
        <div className="flex max-w-2xl items-start gap-6">
          <motion.span
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease }}
            className="hidden border border-harvest/40 p-4 text-harvest sm:block"
          >
            <Smartphone className="h-8 w-8" />
          </motion.span>
          <div>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease }}
              className="text-xs uppercase tracking-[0.3em] text-harvest"
            >
              {app.name || "Jamna App"}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: 0.1, ease }}
              data-testid="app-heading"
              className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-cream sm:text-5xl"
            >
              {t("appHeadA")} <span className="italic text-harvest">{t("appHeadAccent")}</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: 0.15, ease }}
              className="mt-5 max-w-lg text-sm leading-relaxed text-sage sm:text-base"
            >
              {app.desc}
            </motion.p>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2, ease }}
        >
          {app.apkUrl ? (
            <a
              href={app.apkUrl}
              data-testid="app-download-button"
              className="group inline-flex shrink-0 items-center gap-3 bg-harvest px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-forest transition-colors duration-300 hover:bg-harvestHover"
            >
              {t("downloadApk")} {app.version ? `(v${app.version})` : ""}
              <Download className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            </a>
          ) : (
            <span
              data-testid="app-coming-soon"
              className="inline-flex shrink-0 items-center gap-3 border border-line px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-sage"
            >
              {t("comingSoon")}
            </span>
          )}
        </motion.div>
      </div>
    </section>
  );
}
